<template>
    <main class="page-shell narrow">
        <section class="hero-panel text-center">
            <div class="site-logo justify-content-center">
                <img src="/assets/sidestream-logo.svg" alt="" aria-hidden="true">
                <span>sidestream.games</span>
            </div>

            <div class="mt-4">
                <span class="brand-kicker">Stream setup</span>
                <h1 class="brand-title">Connect Twitch.</h1>
                <p class="brand-subtitle">Link your channel, grab the client, and let chat join the game.</p>
            </div>
        </section>

        <TwitchConnect/>
    </main>
</template>

<script>
import TwitchConnect from '@/components/TwitchConnect.vue'

export default {
    name: 'Main',
    components: {
        TwitchConnect
    }
}
</script>

<style scoped>
.hero-panel {
    margin-bottom: 1.5rem;
}
</style>
